import { NodeGraphLink } from "@components/NodeLink/types"
import { AppNode } from "@features/builder/graph/types"
import { atom } from "jotai"
import { atomWithImmer } from "jotai-immer"

export const emptyLink = {
  org: "",
  div: "",
  prod: "",
  family: "",
  version: "",
  node: "",
} as const

export const linkDialogNodeAtom = atom<AppNode>() // node for which the link dialog is open
export const openConfirmDeleteAtom = atom(false)
/** bits to create link: org#div#prod#family_version__node */
export const linkAtom = atomWithImmer<NodeGraphLink>(emptyLink)

if (process.env.NODE_ENV !== "production") {
  linkDialogNodeAtom.debugLabel = "linkDialogNodeAtom"
  openConfirmDeleteAtom.debugLabel = "openConfirmDeleteAtom"
  linkAtom.debugLabel = "linkAtom"
}
